import { Typography } from '@mui/joy';
import type { ReactElement } from 'react';

export const Header4 = ({ title, mb }: { title: string; mb?: number }): ReactElement => {
  /* jscpd:ignore-start */
  return (
    <Typography level="body-md" mb={mb ?? 3}>
      {title}
    </Typography>
  );
  /* jscpd:ignore-end */
};
